module.exports = __webpack_public_path__ + "static/media/1.e05d88b5.jpg";